import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../config/config";
import { getToken } from "../../utils/localStorageMethods";

const apiUrl = config.Url;

export const reservationDetailSlice = createApi({
  reducerPath: "reservationDetailSlice",
  baseQuery: fetchBaseQuery({
    baseUrl: `${apiUrl}/reservations`,
    credentials: "include",
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
        headers.set("ngrok-skip-browser-warning", true);
      }
      return headers;
    },
  }),
  tagTypes: ["ReservationDetail"],
  endpoints: (builder) => ({
    getReservationById: builder.query({
      query: (id) => `/${id}/details`,
      providesTags: ["ReservationDetail"],
    }),
  }),
});

export const { useGetReservationByIdQuery } = reservationDetailSlice;
